import { useEffect, useState } from "react";
import SubscriptionPlanCard from "../components/SubscriptionPlanCard";
import { useDispatch, useSelector } from "react-redux";
import { getPlan } from "../redux/slices/plansSlice";
import axios from "axios";
import { CheckCircle2, AlertTriangle } from "lucide-react";

const SubscriptionPlan = () => {
  const dispatch = useDispatch();
  const [activePlan, setActivePlan] = useState(null);
  const [loadingActivePlan, setLoadingActivePlan] = useState(false);
  const [activePlanError, setActivePlanError] = useState(null);

  const { plans, loading, error } = useSelector((state) => state.plan);
  const user = useSelector((state) => state.auth.user);

  // Obtener planes disponibles
  useEffect(() => {
    if (plans.length === 0) {
      dispatch(getPlan());
    }
  }, [dispatch, plans.length]);
  
  // Obtener el plan activo del usuario
  useEffect(() => {
    const fetchActivePlan = async () => {
      if (!user?.id) return;
      
      try {
        setLoadingActivePlan(true);
        setActivePlanError(null);
        const token = localStorage.getItem("token");
        
        // Obtener las suscripciones del usuario
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL || 'http://localhost:4005'}/api/v1/userSubscriptions/${user.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
          }
        );
        
        // Filtrar para encontrar la suscripción activa
        const now = new Date();
        const activeSubscription = response.data.find(sub => 
          sub.status === "active" && 
          new Date(sub.startDate) <= now && 
          new Date(sub.endDate) > now
        );
        
        if (activeSubscription) {
          // Obtener los detalles del plan
          const planResponse = await axios.get(
            `${process.env.REACT_APP_API_URL || 'http://localhost:4005'}/api/v1/subscriptionPlans/${activeSubscription.subscriptionPlanId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
              },
            }
          );
          
          setActivePlan({
            ...planResponse.data,
            startDate: activeSubscription.startDate,
            endDate: activeSubscription.endDate,
            subscriptionId: activeSubscription.id
          });
        } else {
          setActivePlan(null);
        }
      } catch (error) {
        console.error("Error al obtener el plan activo:", error);
        setActivePlanError("No se pudo cargar tu plan activo");
      } finally {
        setLoadingActivePlan(false);
      }
    };
    
    fetchActivePlan();
  }, [user]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gradient-to-b from-zinc-900 via-zinc-800 to-zinc-900 text-white">
        Cargando planes de suscripción...
      </div>
    );
  }

  if (error && plans.length === 0) {
    return (
      <div className="h-screen flex justify-center items-center bg-gradient-to-b from-zinc-900 via-zinc-800 to-zinc-900 text-red-400 text-center">
        Error: {error}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b bg-black text-white font-montserrat pt-20">
      <div className="container mx-auto px-4 py-8">  
        {loadingActivePlan ? (
          <div className="text-center text-gray-400 mb-6">
            <p>Cargando información de tu plan...</p>
          </div>
        ) : activePlanError ? (
          <div className="flex items-center justify-center text-red-400 mb-6">
            <AlertTriangle className="w-5 h-5 mr-2" />
            <p>{activePlanError}</p>
          </div>
        ) : null}
  
       

        <div className="flex flex-col gap-6 items-center">
          {plans.map((plan) => (
            <SubscriptionPlanCard 
              key={plan.id} 
              plan={plan} 
              isActive={activePlan && activePlan.id === plan.id}
              userHasActivePlan={!!activePlan}
              subscriptionId={activePlan && activePlan.id === plan.id ? activePlan.subscriptionId : null}
            />
          ))}
        </div>
      </div>
    </div>
  );
  
};

export default SubscriptionPlan;
